module.exports = __webpack_public_path__ + "static/media/sluiting.aabbf860.jpg";